import Collection from '../../ModelBinding/Collection';
import Product from './Product';

export default class ProductCollection extends Collection<Product> {
  static getModel() {
    return Product;
  }
}
